import styled from "@emotion/styled";
import { Component, createRef } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { SafeIframe } from "components/safe-iframe/SafeIframe";
import { IFRAME_SCOPES } from "constants/integration-widget";
import { updateQueryString } from "helpers/url";
import { ISelectedWidget } from "interfaces/customerDetailsWidgetInterface";
import {
  IConnection,
  ICustomerDetailsSectionMessage,
  IIframeConnector,
  IInboxMessage,
  InboxMessageTitles,
  connectionPool,
  createConnection,
} from "services/widget";
import { WidgetIntegrationActions } from "store/actions";
import { ApplicationsActions } from "store/features/applications/actions";

interface IStyledContainerProps {
  isVisible: boolean;
}

const StyledContainer = styled.div<IStyledContainerProps>`
  border: 0;
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "flex" : "none")
  };
  flex: 1;
  min-height: 100%;
  min-width: 100%;
  overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
`;

const StyledIframe = styled(SafeIframe)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

export interface IProps {
  widget: ISelectedWidget;
  isVisible: boolean;
  onInboxMessage(message: IInboxMessage): void;
  onCustomerDetailsSectionChange?(message: ICustomerDetailsSectionMessage): void;
  onConnectionEstablished(pluginId: string, connectionId: string): void;
  context?: unknown;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createCustomerDetailsWidget = (iframeConnector: IIframeConnector) =>
  class CustomerDetailsWidget extends Component<IProps> {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props: any) {
      super(props);

      const { widget } = props;
      this.url = updateQueryString(widget.url, "plugin_id", widget.id);
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    componentDidMount() {
      if (this.iframe.current) {
        // Configure url after pushing iframe to the DOM to avoid race condition
        // between connection handshake and iframe load event.
        this.iframe.current.src = this.url;
      }
      // @ts-expect-error TS(2345)
      this.connection = iframeConnector(this.iframe.current, this.url);
      this.configureConnection();
    }

    shouldComponentUpdate(nextProps: IProps): boolean {
      const { widget, isVisible } = this.props;
      // Assingning new promise to connection allows us to keep
      // context assignment order
      this.connection = this.connection.then(conn => {
        conn.setContext(nextProps.context || {});
        return conn;
      });

      // The update should be necessary, only if the widget or the visibility flag
      // have changed, otherwise the re-render can be skipped. The only case to
      // handle then is to examine the passed message and send it through
      // the connection, if the it is different than the previous message.
      if (nextProps.widget !== widget || nextProps.isVisible !== isVisible) {
        return true;
      }

      return false;
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    componentWillUnmount() {
      this.destroyConnection();
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    handleCustomerDetailsMessage = (msg: IInboxMessage) => {
      const { onCustomerDetailsSectionChange } = this.props;
      if (onCustomerDetailsSectionChange && msg.title === InboxMessageTitles.CustomerDetailsSection) {
        onCustomerDetailsSectionChange(msg as ICustomerDetailsSectionMessage);
      }
    };

    // @ts-expect-error TS(2564): Property 'connection' has no initializer and is no... Remove this comment to see the full error message
    private connection: Promise<IConnection>;
    private iframe = createRef<HTMLIFrameElement>();
    private url: string;

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    private configureConnection() {
      this.connection = this.connection.then(connection => {
        connection.setContext(this.props.context || {});
        connectionPool.add(this.props.widget.id, connection);
        connection.subscribe(this.props.onInboxMessage);
        connection.subscribe(this.handleCustomerDetailsMessage);
        connection.initialize();
        if (this.props.onConnectionEstablished) {
          this.props.onConnectionEstablished(this.props.widget.id, connection.connectionId);
        }
        return connection;
      });
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    private destroyConnection() {
      this.connection.then(connection => {
        connectionPool.remove(connection.connectionId);
        try {
          connection.destroy();
        } catch (err) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          if (err.code !== "DESTROYED") {
            throw err;
          }
        }
      });
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    render() {
      return (
        <StyledContainer isVisible={this.props.isVisible}>
          <StyledIframe ref={this.iframe} allow={IFRAME_SCOPES} />
        </StyledContainer>
      );
    }
  };

export const CustomerDetailsWidget = createCustomerDetailsWidget(createConnection);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch) => ({
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onInboxMessage(message: IInboxMessage, connectionId: string) {
    // @ts-expect-error TS(2345)
    dispatch(WidgetIntegrationActions.receiveInboxMessage(message, connectionId));
  },
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onConnectionEstablished(pluginId: string, connectionId: string) {
    // @ts-expect-error TS(2345)
    dispatch(ApplicationsActions.connectionEstablished(pluginId, connectionId));
  },
});

export const CustomerDetailsWidgetContainer = connect(null, mapDispatchToProps)(CustomerDetailsWidget);
